import { Controller } from "@hotwired/stimulus"
import { trackEvent } from "../utils/analytics"
import { recordPwaInstallation } from "../pwa/pwaInstallationRecorder"
import { isPwaEnabled } from "../utils/offline_gating"

export default class extends Controller {
  connect() {
    this.handleBeforeInstallPrompt = this.onBeforeInstallPrompt.bind(this)
    window.addEventListener("beforeinstallprompt", this.handleBeforeInstallPrompt)
  }

  disconnect() {
    window.removeEventListener("beforeinstallprompt", this.handleBeforeInstallPrompt)
  }

  onBeforeInstallPrompt(event) {
    event.preventDefault()
    this.deferredPrompt = event
    if (!this.shouldShowPrompt()) return
    this.showModal()
  }

  shouldShowPrompt() {
    return (
      isPwaEnabled() &&
      !this.isStandalone() &&
      localStorage.getItem("pwaInstallPromptDismissed") !== "true"
    )
  }

  isStandalone() {
    return (
      window.matchMedia?.("(display-mode: standalone)").matches ||
      navigator.standalone === true
    )
  }

  showModal() {
    if (!window.Swal) return
    trackEvent("pwa_install_prompt_shown", {})
    window.Swal.fire({
      title: "Install Aquifer for quick access.",
      html: "Open Aquifer from your home screen or desktop in its own full-screen window. Aquifer also keeps recently visited pages available if your connection drops, and saves your progress until you’re back online.",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Install now",
      confirmButtonAriaLabel: "Install the Aquifer app",
      denyButtonText: "Not now",
      denyButtonAriaLabel: "Dismiss install prompt",
      customClass: {
        confirmButton: 'aq-button-2 medium with-margin',
        denyButton: 'aq-button-2 medium with-margin outline black',
      },
      buttonsStyling: false,
    }).then((result) => {
      if (result.isConfirmed) {
        this.install()
      } else if (result.isDenied) {
        this.dismiss()
      }
    })
  }

  async install() {
    if (!this.deferredPrompt) return
    await this.deferredPrompt.prompt()
    const choice = await this.deferredPrompt.userChoice
    this.deferredPrompt = null
    if (choice?.outcome === "accepted") {
      trackEvent("pwa_install_accepted", {})
      recordPwaInstallation({ force: true })
    }
  }

  dismiss() {
    localStorage.setItem("pwaInstallPromptDismissed", "true")
    trackEvent("pwa_install_dismissed", {})
  }
}
